<template lang="pug">
  .election-component(:election-embed="embed", :class="className", v-bind="customAttributes")
    slot(name="nav")
    slot(name="title")
      GroupTitle(v-if="titleProps.title", v-bind="titleProps")

    .election-component_content
      slot

    Disclaimer(
      v-if="disclaimerConfig",
      :embed="embed",
      :loading="loading",
      :text="disclaimerConfig.text",
      :link="disclaimerConfig.link",
      :indexLink="disclaimerConfig.indexLink",
      :linkText="disclaimerConfig.linkText"
    )
    Error(:error="error")
    DebugLogs(:debug="debug")

</template>

<script>
import GroupTitle from '../GroupTitle/GroupTitle.vue';
import Error from '../Error/Error.vue';
import DebugLogs from '../DebugLogs/DebugLogs.vue';
import Disclaimer from '../../components/Disclaimer/Disclaimer';

export default {
  name: 'euiContainer',
  props: {
    embed: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    className: {
      type: String
    },
    customAttributes: {
      type: Object,
      default: () => ({})
    },
    titleProps: {
      type: Object,
      default: () => ({})
    },
    disclaimerConfig: {
      type: Object,
    },
    error: {
      type: String,
    },
    debug: {
      type: Array
    }
  },
  components: { GroupTitle, Error, DebugLogs, Disclaimer },
};
</script>

<style lang="scss">
@import "src/core/scss/global-sass";
.election-component {
  position: relative;
  width: 100%;

  &_content {
    width: 100%;
  }

  &-title {
    margin-bottom: var(--spacing-unit-x2);
  }
}
</style>
